(function () {
  'use strict';

  function moneyFromCents(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD'
      }).format((cents || 0) / 100);
    } catch (error) {
      return '$' + (((cents || 0) / 100).toFixed(2));
    }
  }

  function hideNativeSubscriptionFallbacks() {
    if (!document.querySelector('[data-nbp-top-section]')) return;

    const appSelectors = [
      '.shopify_subscriptions_app_block',
      '.shopify-subscriptions-app-block',
      '.shopify_subscriptions_app_container',
      '.shopify-subscriptions-app-container',
      '.shopify_subscriptions_purchase_option_wrapper',
      '.shopify_subscriptions_app_policy',
      '.subscriptions_app_embed_block'
    ];

    document.querySelectorAll(appSelectors.join(',')).forEach(function (node) {
      if (node.closest('[data-nbp-top-section]')) return;
      node.hidden = true;
      node.style.display = 'none';
    });

    const fallbackTexts = [
      'Subscription widget will only show on products that have a subscription plan attached to them.',
      'To edit the placement of the subscription widget',
      "<div class='subscriptions_app_embed_block'></div>"
    ];

    Array.from(document.querySelectorAll('body div, body section, body form, body fieldset, body aside')).forEach(function (node) {
      if (node.closest('[data-nbp-top-section]')) return;
      if (node.matches('body, main, .content-for-layout')) return;

      const text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      const isInstruction = fallbackTexts.some(function (fallbackText) {
        return text.indexOf(fallbackText) !== -1;
      });
      const isNativeWidget = text.indexOf('One-time purchase') !== -1
        && text.indexOf('Subscribe and save') !== -1
        && text.indexOf('Deliver every') !== -1;

      if (!isInstruction && !isNativeWidget) return;
      node.hidden = true;
      node.style.display = 'none';
    });
  }

  function watchNativeSubscriptionFallbacks() {
    if (window.__nbpSubscriptionFallbackWatcher) return;
    window.__nbpSubscriptionFallbackWatcher = true;

    hideNativeSubscriptionFallbacks();
    window.setTimeout(hideNativeSubscriptionFallbacks, 250);
    window.setTimeout(hideNativeSubscriptionFallbacks, 1000);
    window.setTimeout(hideNativeSubscriptionFallbacks, 2500);

    if (!window.MutationObserver) return;
    new MutationObserver(hideNativeSubscriptionFallbacks).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function initTop(section) {
    const stage = section.querySelector('[data-nbp-stage]');
    if (!stage) return;

    const slides = Array.from(stage.querySelectorAll('.nbp-slide'));
    const thumbs = Array.from(section.querySelectorAll('.nbp-thumb'));
    const nav = stage.querySelector('.nbp-stage__nav');
    const prev = stage.querySelector('[data-nbp-prev]');
    const next = stage.querySelector('[data-nbp-next]');
    const form = section.querySelector('form.nbp-product-form');
    if (!form) return;

    const variantInput = form.querySelector('[name="id"]');
    const quantityInput = form.querySelector('[data-nbp-qty-input]');
    const priceLabel = section.querySelector('[data-nbp-price-label]');
    const sizeLabel = section.querySelector('[data-nbp-size-label]');
    const ctaPrices = Array.from(section.querySelectorAll('[data-nbp-cta-price]'));
    const stickyOption = section.querySelector('[data-nbp-sticky-option]');
    const soldOutLabel = section.querySelector('[data-nbp-soldout-label]');
    const addButtons = Array.from(section.querySelectorAll('[data-nbp-add]'));
    const addLabels = Array.from(section.querySelectorAll('[data-nbp-add-label]'));
    const stickyCart = section.querySelector('[data-nbp-sticky-cart]');
    const sizeButtons = Array.from(section.querySelectorAll('.nbp-size-chip'));
    const grindButtons = Array.from(section.querySelectorAll('.nbp-grind-chip'));
    const sellingPicker = section.querySelector('[data-nbp-selling-plan-picker]');
    const sellingPlanInput = section.querySelector('[data-nbp-selling-plan-input]');
    const sellingModeButtons = Array.from(section.querySelectorAll('[data-nbp-selling-mode]'));
    const sellingPlanButtons = Array.from(section.querySelectorAll('[data-nbp-selling-plan]'));
    const sellingPlansWrap = section.querySelector('[data-nbp-selling-plans]');
    const oneTimeMeta = section.querySelector('[data-nbp-onetime-meta]');
    const subscribeMeta = section.querySelector('[data-nbp-subscribe-meta]');
    const sellingSave = section.querySelector('[data-nbp-selling-save]');

    let currentIndex = 0;
    const total = slides.length || 1;

    function showSlide(index) {
      currentIndex = ((index % total) + total) % total;
      slides.forEach(function (slide, idx) {
        slide.classList.toggle('is-active', idx === currentIndex);
      });
      thumbs.forEach(function (thumb, idx) {
        const active = idx === currentIndex;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      const currentSlide = slides[currentIndex];
      const darkMode = currentSlide && currentSlide.classList.contains('nbp-slide--photo');
      if (nav) nav.classList.toggle('is-dark', darkMode);
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        showSlide(index);
      });
    });

    if (prev) prev.addEventListener('click', function () { showSlide(currentIndex - 1); });
    if (next) next.addEventListener('click', function () { showSlide(currentIndex + 1); });

    stage.setAttribute('tabindex', '0');
    stage.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') showSlide(currentIndex - 1);
      if (event.key === 'ArrowRight') showSlide(currentIndex + 1);
    });

    let touchStartX = 0;
    stage.addEventListener('touchstart', function (event) {
      touchStartX = event.touches[0].clientX;
    }, { passive: true });
    stage.addEventListener('touchend', function (event) {
      const dx = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) showSlide(currentIndex + (dx < 0 ? 1 : -1));
    });

    const variantsDataElement = section.querySelector('[data-nbp-variants-json]');
    const variants = variantsDataElement ? JSON.parse(variantsDataElement.textContent) : [];
    const currency = section.dataset.nbpCurrency || 'USD';
    const initialVariantId = Number(section.dataset.nbpInitialVariantId || 0);

    const state = {
      variantId: initialVariantId,
      size: '',
      grind: '',
      sellingMode: 'onetime',
      sellingPlanId: sellingPlanButtons[0] ? Number(sellingPlanButtons[0].dataset.nbpSellingPlan || 0) : null,
      quantity: Math.max(1, parseInt(quantityInput ? quantityInput.value : '1', 10))
    };

    function getSellingPlan(variant, planId) {
      const plans = variant && Array.isArray(variant.sellingPlans) ? variant.sellingPlans : [];
      return plans.find(function (plan) {
        return Number(plan.id) === Number(planId);
      }) || plans[0] || null;
    }

    function savingsPercent(variant, plan) {
      if (!variant || !plan || !variant.price || plan.price >= variant.price) return 0;
      return Math.round(((variant.price - plan.price) / variant.price) * 100);
    }

    function getVariant() {
      if (state.size || state.grind) {
        const matched = variants.find(function (variant) {
          const sizeMatches = !state.size || variant.option1 === state.size;
          const grindMatches = !state.grind || variant.option2 === state.grind;
          return sizeMatches && grindMatches;
        });
        if (matched) return matched;
      }
      return variants.find(function (variant) {
        return Number(variant.id) === Number(state.variantId);
      }) || variants[0];
    }

    function updateAvailability() {
      sizeButtons.forEach(function (button) {
        const size = button.dataset.size || '';
        const hasMatch = variants.some(function (variant) {
          const sizeMatches = variant.option1 === size;
          const grindMatches = !state.grind || variant.option2 === state.grind;
          return sizeMatches && grindMatches && variant.available;
        });
        button.classList.toggle('is-disabled', !hasMatch);
        button.disabled = !hasMatch;
        button.setAttribute('aria-disabled', hasMatch ? 'false' : 'true');
      });

      grindButtons.forEach(function (button) {
        const grind = button.dataset.grind || '';
        const hasMatch = variants.some(function (variant) {
          const sizeMatches = !state.size || variant.option1 === state.size;
          const grindMatches = variant.option2 === grind;
          return sizeMatches && grindMatches && variant.available;
        });
        button.classList.toggle('is-disabled', !hasMatch);
        button.disabled = !hasMatch;
        button.setAttribute('aria-disabled', hasMatch ? 'false' : 'true');
      });
    }

    function render() {
      const variant = getVariant();
      if (!variant) return;

      state.variantId = variant.id;
      state.size = variant.option1 || '';
      state.grind = variant.option2 || '';
      if (variantInput) variantInput.value = variant.id;
      if (quantityInput) quantityInput.value = String(state.quantity);

      const displayPrice = moneyFromCents(variant.price, currency);
      const activePlan = getSellingPlan(variant, state.sellingPlanId);
      const hasSellingPlans = Boolean(activePlan);
      if (!hasSellingPlans) state.sellingMode = 'onetime';
      if (state.sellingMode === 'subscribe' && activePlan) {
        state.sellingPlanId = Number(activePlan.id);
      }
      const activeSellingPlan = getSellingPlan(variant, state.sellingPlanId);
      const selectedPrice = state.sellingMode === 'subscribe' && activeSellingPlan
        ? moneyFromCents(activeSellingPlan.price, currency)
        : displayPrice;

      if (priceLabel) priceLabel.textContent = selectedPrice;
      if (sizeLabel) sizeLabel.textContent = variant.option1 || variant.title;
      ctaPrices.forEach(function (label) {
        label.textContent = selectedPrice;
      });
      if (stickyOption) {
        stickyOption.textContent = [variant.option1, variant.option2].filter(Boolean).join(' / ') || variant.title;
      }
      if (soldOutLabel) soldOutLabel.textContent = variant.available ? 'In stock' : 'Sold out';
      addButtons.forEach(function (button) {
        button.disabled = !variant.available;
      });
      addLabels.forEach(function (label) {
        label.textContent = variant.available ? 'Add to cart' : 'Sold out';
      });

      sizeButtons.forEach(function (button) {
        const active = button.dataset.size === state.size;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-checked', active ? 'true' : 'false');
      });

      grindButtons.forEach(function (button) {
        const active = button.dataset.grind === state.grind;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-checked', active ? 'true' : 'false');
      });

      if (sellingPicker) {
        sellingPicker.hidden = !hasSellingPlans;
      }

      if (sellingPlanInput) {
        const shouldSubmitPlan = state.sellingMode === 'subscribe' && activeSellingPlan;
        sellingPlanInput.disabled = !shouldSubmitPlan;
        sellingPlanInput.value = shouldSubmitPlan ? activeSellingPlan.id : '';
      }

      sellingModeButtons.forEach(function (button) {
        const mode = button.dataset.nbpSellingMode || 'onetime';
        const active = mode === state.sellingMode;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-checked', active ? 'true' : 'false');
        if (mode === 'subscribe') button.disabled = !hasSellingPlans;
      });

      if (sellingPlansWrap) {
        const showPlans = state.sellingMode === 'subscribe' && hasSellingPlans;
        sellingPlansWrap.classList.toggle('is-open', showPlans);
        sellingPlansWrap.setAttribute('aria-hidden', showPlans ? 'false' : 'true');
      }

      if (oneTimeMeta) oneTimeMeta.textContent = displayPrice + ' - ship once';
      if (subscribeMeta && activePlan) subscribeMeta.textContent = moneyFromCents(activePlan.price, currency) + ' - recurring delivery';

      const percent = savingsPercent(variant, activePlan);
      if (sellingSave) {
        sellingSave.hidden = percent <= 0;
        sellingSave.textContent = percent > 0 ? 'Save ' + percent + '%' : '';
      }

      sellingPlanButtons.forEach(function (button) {
        const planId = Number(button.dataset.nbpSellingPlan || 0);
        const plan = getSellingPlan(variant, planId);
        const active = activeSellingPlan && Number(activeSellingPlan.id) === planId;
        const price = button.querySelector('[data-nbp-selling-plan-price]');
        button.disabled = !plan;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-checked', active ? 'true' : 'false');
        if (price) price.textContent = plan ? moneyFromCents(plan.price, currency) : '';
      });

      updateAvailability();
    }

    sizeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;
        state.size = button.dataset.size || state.size;
        render();
      });
    });

    grindButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;
        state.grind = button.dataset.grind || state.grind;
        render();
      });
    });

    sellingModeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;
        state.sellingMode = button.dataset.nbpSellingMode || 'onetime';
        render();
      });
    });

    sellingPlanButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;
        state.sellingMode = 'subscribe';
        state.sellingPlanId = Number(button.dataset.nbpSellingPlan || 0);
        render();
      });
    });

    const qtyDec = section.querySelector('[data-nbp-qty-dec]');
    const qtyInc = section.querySelector('[data-nbp-qty-inc]');

    function normalizeQty() {
      state.quantity = Math.max(1, Math.min(99, parseInt(quantityInput ? quantityInput.value : '1', 10) || 1));
      if (quantityInput) quantityInput.value = String(state.quantity);
    }

    if (qtyDec) qtyDec.addEventListener('click', function () {
      normalizeQty();
      state.quantity = Math.max(1, state.quantity - 1);
      render();
    });

    if (qtyInc) qtyInc.addEventListener('click', function () {
      normalizeQty();
      state.quantity = Math.min(99, state.quantity + 1);
      render();
    });

    if (quantityInput) {
      quantityInput.addEventListener('change', function () {
        normalizeQty();
        render();
      });
    }

    if (stickyCart) {
      const showStickyCart = function () {
        const trigger = section.querySelector('.nbp-cta-block') || form || section;
        const rect = trigger.getBoundingClientRect();
        const shouldShow = window.scrollY > 120 && rect.bottom < 80;
        stickyCart.classList.toggle('is-visible', shouldShow);
      };

      showStickyCart();
      window.addEventListener('scroll', showStickyCart, { passive: true });
      window.addEventListener('resize', showStickyCart);
    }

    form.addEventListener('submit', function () {
      normalizeQty();
      render();
    });

    render();
    showSlide(0);
  }

  function initFaq(section) {
    const allDetails = Array.from(section.querySelectorAll('.nbp-faq-list details'));
    if (!allDetails.length) return;

    allDetails.forEach(function (detail) {
      detail.addEventListener('toggle', function () {
        if (detail.open) {
          allDetails.forEach(function (other) {
            if (other !== detail) other.open = false;
          });
        }
      });
    });

    section.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        allDetails.forEach(function (detail) {
          detail.open = false;
        });
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-nbp-top-section]').forEach(initTop);
    document.querySelectorAll('[data-nbp-faq-section]').forEach(initFaq);
    watchNativeSubscriptionFallbacks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
